<template>
  <div :class="['badge-status', scheme]">
    <slot />
  </div>
</template>

<script setup lang="ts">
const { scheme = 'grey' } = defineProps<{
  scheme?: 'grey' | 'blue' | 'purple' | 'green' | 'yellow' | 'orange'
}>()
</script>

<style lang="scss" scoped>
@use 'sass:map';

$statuses: (
  'grey': (
    bg: $statusGreyLight,
    text: $statusGrey,
  ),
  'blue': (
    bg: $statusBlueLight,
    text: $statusBlue,
  ),
  'purple': (
    bg: $statusPurpleLight,
    text: $statusPurple,
  ),
  'green': (
    bg: $statusGreenLight,
    text: $statusGreen,
  ),
  'yellow': (
    bg: $statusYellowLight,
    text: $statusYellow,
  ),
  'orange': (
    bg: $statusOrangeLight,
    text: $statusOrange,
  ),
);

@mixin status-scheme($map) {
  @each $name, $colors in $map {
    $bg: map.get($colors, bg);
    $text: map.get($colors, text);

    &.#{$name} {
      background-color: $bg;
      color: $text;
    }
  }
}

.badge-status {
  padding: 4px 8px;
  border-radius: 5px;
  max-width: max-content;
  text-wrap-mode: nowrap;
  @include heading(12px);

  @include status-scheme($statuses);
}
</style>
